
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { BiPaiGoldGameResultData } from "./bipai_gameresult_interface";
import Utility from "../../../../utility/utility";
import GameUtil from "../../../../utility/game_util";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/bipai/BiPaiGoldOneGameResultDetail')
export default class BiPaiGoldOneGameResultDetail extends cc.Component {

    @property(cc.Label)
    labelOpeningMultiple: cc.Label = null

    @property(cc.Label)
    labelFirstOpenMultiple: cc.Label = null

    @property(cc.Label)
    labelFollowMultiple: cc.Label = null

    @property(cc.Label)
    labelNormalOpenMultiple: cc.Label = null

    @property(cc.Label)
    labelSpecailOpenMultiple: cc.Label = null

    @property(cc.Label)
    labelZiMoMultiple: cc.Label = null

    @property(cc.Label)
    labelFangPaoMultiple: cc.Label = null

    @property(cc.Label)
    labelRoundScore: cc.Label = null

    @property(cc.Label)
    labelFollowScore: cc.Label = null

    showDetail(show: boolean, intentData?: BiPaiGoldGameResultData){         
        this.node.active = !!show
        if(!show){
            return
        }
        this.showMutipleLabel(this.labelOpeningMultiple, intentData.openingMultiple)        
        this.showMutipleLabel(this.labelFirstOpenMultiple, intentData.firstOpenMultiple)
        this.showMutipleLabel(this.labelFollowMultiple, intentData.followMultiple)
        this.showMutipleLabel(this.labelNormalOpenMultiple, intentData.normalOpenMultiple)
        this.showMutipleLabel(this.labelSpecailOpenMultiple, intentData.specailOpenMultiple)
        this.showMutipleLabel(this.labelZiMoMultiple, intentData.ziMoMultiple)
        this.showMutipleLabel(this.labelFangPaoMultiple, intentData.fangPaoMultiple)

        if(intentData.followScore >= 0){
            this.labelFollowScore.string = '+' + GameUtil.currencyFormatting(intentData.followScore)
        }else{
            this.labelFollowScore.string = '' + GameUtil.currencyFormatting(intentData.followScore)
        }

        if(intentData.roundScore >= 0){
            this.labelRoundScore.string = '+' + GameUtil.currencyFormatting(intentData.roundScore)
        }else{
            this.labelRoundScore.string = '' + GameUtil.currencyFormatting(intentData.roundScore)
        }

    }

    protected showMutipleLabel(label: cc.Label, multiple: number, hideX?){
        if(multiple && multiple > 1){
            label.string = (hideX? '' :'x') + multiple
            label.node.active = true
            this.setGray(label.node.parent, false)
        }else{
            label.node.active = false
            this.setGray(label.node.parent, true)
        }
    }

    protected setGray(node: cc.Node, gray: boolean){
        let nodeTitle = node.getChildByName('title')        
        let nodeTitle1 = node.getChildByName('grayTitle')
        nodeTitle && (nodeTitle.active = !gray)
        nodeTitle1 && (nodeTitle1.active = !!gray)
    }

}
